export default {
    add_call_task: "Чалуу үчүн тапшырманы кошуу",
    add_to_funnel: "Воронкага кошуу",
    add_to_funnel_came_and_repeated: "'Жетишкен жана кайталанган' воронкасына кошуу",
    all_days: "Бардык күндөр",
    all_doctors: "Бардык дарыгерлер",
    all_plan_treatment_doctors: "Бардык дарыгерлер дарылоо пландары",
    amo_deal_id: "Amo келишиминин ID",
    api_key: "API ачкычы",
    applications_and_appeals: "Өтүнмөлөр жана кайрылуулар",
    are_you_sure_you_want_to_delete_task: "Тапшырманы чын эле жок кылгыңыз келеби?",
    ask_for_confirmation_response_from_patient: "Бейтаптан ырастоо жообун талап кылуу",
    attach_file: "Файлды тиркөө",
    authorized: "Авторизацияланган",
    auto: "Автоматтык",
    binotel: "Binotel",
    binotel_integration: "Binotel менен интеграция",
    binotel_integration_instructions: "Dentist Plus менен Binotelди интеграциялоо үчүн сизге  керек: <br>1. Binotelде аккаунт түзүү<br>2. Binotel колдоо кызматына кат жазыңыз, анда үчүн төмөнкү webhook орнотуу өтүнүчү менен кайрылыңыз <b>API CALL SETTINGS</b> жана <b>API CALL COMPLETED</b>:<br><span class='text-primary'>{url}</span><br>3. Төмөнкү талаада binotel функциясын колдоно турган клиниканын кызматкерлеринен колдонуучуларды көрсөтүңүз:",
    binotel_internal: "Binotel ички телефону",
    binotel_key: "Binotel ачкычы",
    binotel_secret: "Binotel жашыруун ачкычы",
    button_title: "Баскычтын аталышы",
    call_from_patient: "Бейтаптан чалуу",
    call_from_phone: "Номерден чалуу",
    call_noun: "Чалуу",
    callee: "Кимге чалып жаткан адам",
    came_and_repeated: "Жетишкен жана кайталанган",
    canban_mode: "Funnel режими",
    cancel_sending: "Жөнөтүүнү жокко чыгаруу",
    cancellation_response: "Визитти жокко чыгаруу үчүн жооп",
    change_status: "Статусту өзгөртүү",
    client_comment: "Клиенттин комментарийи",
    close_the_integration_for_this_branch: "Бул филиал үчүн интеграцияны жабыңыз",
    confirmation_response: "Визитиңизди ырастоо үчүн жооп бериңиз",
    copied: "Көчүрүлгөн",
    copy_to_clipboard: "Буферге көчүрүү",
    create_application_on_call: "Өтүнмөдө жана кайрылууда автоматтык түрдө чалуу карточкасын түзүү",
    create_card_automatically: "Автоматтык түрдө карточканы түзүү",
    create_lead: "Кайрылууну түзүү",
    create_lead_on_incoming_message_if_no_lead: "Статус \"Жазылды\" дегенге чейин активдүү сурам жок болсо, WhatsAppта кирүүчү билдирүүлөр үчүн сурам түзүңүз",
    create_lead_on_incoming_messages: "Белгисиз номерден келген WhatsApp өтүнмөлөрүнө сурам түзүңүз",
    created_visit_administrator: "Сапарды түзгөн администратор",
    crm: "CRM",
    curator_assigned: "Куратор дайындалды",
    deadline: "Аткаруу мөөнөтү",
    deal: "Келишим",
    do_not_create_duplicates: "Дубликаттарды түзбөңүз",
    do_not_create_duplicates_on_call: "Статуска чейинки активдүү өтүнмө бар болсо, чалуулар боюнча дубликаттарды түзбөңүз \"Жазылган\"",
    do_not_create_duplicates_on_messages: "\"Жазылган\" статусу менен активдүү суроо-талап бар болсо, кирүүчү билдирүүлөр үчүн дубликаттарды түзбөңүз",
    do_not_create_lead_if_patient_exists: "Эгерде бейтап маалымат базасында болсо, өтүнмө түзбөңүз",
    do_not_show_anymore: "Кайра көрсөтпөө",
    domain: "Домен",
    during_incoming: "Киргенде",
    during_outcoming: "Чыгуу үчүн",
    feedback: "Сын-пикир",
    feedbacks: "Сын-пикирлер",
    finish_authorization: "Толук авторизация",
    follow: "Өтүү",
    for_came_from_lead_funnel: "'Жетишкен жана кайталанган' воронкадан чыккандар үчүн",
    for_came_on_first_visit: "Биринчи визитке келгендер үчүн",
    for_came_to_consultation: "Консультацияга келгендер үчүн",
    for_incoming: "Кирүүчүлөр үчүн",
    for_missed: "Өткөрүлгөндөр үчүн",
    for_outcoming: "Чыгуучулар үчүн",
    funnel_came_and_repeated: "Воронка: Жетишкен жана кайталанган",
    generate_key: "Ачкычты түзүү",
    get_gift: "Белек алуу",
    get_sms: "смс алуу",
    has_overdue_tasks: "Кечиктирилген тапшырмалары бар",
    has_tasks: "Тапшырмалары бар",
    has_today_task: "Бүгүнкү күндө тапшырмалары бар",
    has_visit: "Баруу",
    if_lead_has_no_responsible_then_assign_to_this_person_on_first_save: "Эгерде өтүнмөдө жооптуу адамы жок болсо, анда биринчи сактоодо аны дайындаңыз",
    inprogress: "Иштетилүүдө",
    insert_script_one_time_instruction: "Бул скриптти сайттын <head> секциясында орнотуңуз",
    insert_widget_button_instruction: "Бул баскычтын кодун жайгашкан жерине коюңуз",
    instruction: "Нускама",
    integration_key: "Интеграциянын ачкычы",
    internal_phone: "Ички телефон",
    last_30_days: "Акыркы 30 күн",
    last_thirty_days: "Акыркы 30 күн",
    lead_channel: "Өтүнмө каналы",
    leave_comment: "Комментарий калтыруу",
    manually_selected_user: "Кол менен тандалган колдонуучу",
    mark_as_completed: "Аткарылган деп белгилөө",
    mark_as_finished: "Аткарылган деп белгилөө",
    mark_as_in_progress: "Иштетилүүдө деп белгилөө",
    message_template: "Билдирүү үлгүсү",
    message_templates: "Билдирүү калыптары",
    messenger: "Messenger",
    messengers: "Мессенджерлер",
    move_to_funnel_came_and_repeated: "'Жетишкен жана кайталанган' воронкасына жылдыруу",
    my_deals: "Менин келишимдерим",
    my_tasks: "Менин тапшырмаларым",
    no_rating: "Рейтинг жок",
    nobody: "Эч ким",
    one_patient_one_lead: "Бир бейтап - бир келишим",
    open_whatsapp: "whatsapp ачуу",
    outgoing_calls_through: " аркылуу чыгуучу чалуулар",
    overdue: "Мөөнөтү өтүп кеткен",
    patient_already_has_active_deal: "Бейтаптын активдүү келишими бар: {dealId}",
    patient_curator: "Пациенттин супервайзери",
    patient_deposit_sum: "Бейтаптын аманатынын суммасы",
    patient_has_no_future_visits_continue: "Бейтап үчүн келечектеги визиттер табылган жок. Баары бир улантуу керекпи?",
    patient_lost: "Оорулуу жоголду",
    patient_not_derived: "Бейтап аныкталган жок",
    patient_not_derived_from_phone: " {phone} номеринен чалуу - бейтап аныкталган жок",
    patient_stopped_treatment: "Оорулуу дарылоону үзгүлтүккө учуратты",
    paused: "Тыныгуу",
    pbx: "PBX",
    pbx_integration_instructions: "Dentist Plus менен PBX интеграциялоо үчүн зарыл: <br>1. PBX<br>2 аккаунт түзүү. Сиздин PBX жеке кабинетиңизде Webhooks бөлүмүндө url дарегин кошуңуз:<br><span class='text-primary'>{url}</span> жана API.<br>3 бөлүмүндө интеграция ачкычын алыңыз. Төмөнкү талаада pbx функцияларын колдоно турган клиниканын кызматкерлеринен колдонуучуларды көрсөтүңүз жана төмөндөгү калган талааларды толтуруңуз:",
    phone_max_instructions: "Авторизациялоону баштоодон мурун телефон номериңиз мобилдик тиркеме аркылуу MAX мессенжер аккаунтунда катталганын текшериңиз. Тиешелүүлүгүнө жараша 7 жана 375 аймак коддору менен Россия Федерациясынын жана Беларусь Республикасынын телефон номерлерине гана уруксат берилет. Мисалы: 79991234567 же 375291234567",
    plan_treatments: "Дарылоо пландары",
    planned: "Пландаштырылган",
    publish: "Жарыялоо",
    published: "Жарыяланган",
    rating: "Рейтинг",
    recall: "Кайра чалуу",
    recall_on_lead: "'{title}' өтүнмөсү боюнча кайра чалуу",
    record_myself: "Жазылуу",
    record_on_visit: "Кабыл алууга жазылуу",
    recorded_on_visit: "Кабыл алууга жазылган",
    request_qr: "QR сураңыз",
    responsible: "Жооптуу",
    responsible_on_call: "Чалуу үчүн жооптуу адам",
    responsible_on_other_leads_not_created_manually: "Кол менен түзүлбөгөн башка суроо-талаптар үчүн жооптуу",
    responsible_type_in_task: "Тапшырма үчүн жооптуу адамдын түрү",
    responsible_user: "Жооптуу колдонуучу",
    resume_mailing: "Почта жөнөтүүнү улантуу",
    sales_funnel: "Сатуу воронкасы",
    search_by_name: "Аты боюнча издөө",
    search_by_phone: "Телефон боюнча издөө",
    see_later: "Кийинчерээк көрүү",
    select_user: "Колдонуучуну тандаңыз",
    send_feedback_link_to_patient: "Бейтапка карап чыгуу үчүн шилтеме жөнөтүңүз",
    send_receipt_to_patient: "Бейтапка квитанция жөнөтүңүз",
    sent_error: "Ката жөнөтүү",
    show_call_card: "Чалуу картасын көрсөтүү",
    sipuni: "Sipuni",
    sipuni_integration_instructions: "Dentist Plus менен Sipuni интеграциялоо үчүн зарыл: <br>1. Sipuni<br>2 аккаунт түзүү. Sipuni жеке кабинетиңизде API бөлүмүндө интеграциялоо ачкычын түзүп, 'Номерге чалуу' жана  'АТС окуялары'пунктунда 'кызматты кошуу' баскычын басыңыз, ошондой эле 'АТС окуялары'пунктунда 'Алуучу скрипттин URL дарегин' көрсөтүңүз:<br><span class='text-primary'>{url}</span><br>3. Төмөнкү талаада sipuni функциясын колдоно турган клиниканын кызматкерлеринен колдонуучуларды белгилеңиз жана төмөндөгү калган талааларды толтуруңуз:",
    sms_code: "SMS коду",
    soon: "Жакында",
    stage: "Этап",
    stages: "Этаптар",
    start_period: "Башталыш күнү",
    system_number: "Системадагы номер",
    task: "Тапшырма",
    task_date: "Тапшырманын датасы",
    task_type: "Тапшырманын түрү",
    tasks_and_calls: "Тапшырмалар жана чалуулар",
    tilda_integration_instructions: "Tilda веб-сайтыңыздагы формалардан вебхуктарды алуу жана dentist-plus тутумунда лиддерди түзүү үчүн сизге төмөнкүлөр керек:<br/>1. Tilda жеке кабинетиңизде сайттын орнотууларына кирип, → Формалар → Webhook<br/>2. Webhook URL талаасында <span class='text-primary'>{url}</span><br>3 киргизиңиз. API METHOD талаасында 'HEADER' тандаңыз, 'Field name' талаасында 'API-KEY' толтуруңуз, жана төмөндө түзүп алуучу 'Api key' талаасында ачкычты көчүрүңүз.<br/>4. Кошумча орнотууларда активдештириңиз 'Жөнөтүү Cookies'.<br/>5. Формалардагы төмөнкү талаалар dentist-plus тутумунда автоматтык түрдө толтурулат: <b>name, phone, email, comment</b>.",
    treatment_plan_created_2: "Дарылоо планы түзүлдү",
    treatment_plan_finished: "Дарылоо планы аяктады",
    treatment_plan_signed: "Дарылоо планына кол коюлду",
    treatment_refused: "Дарылоодон баш тартуу",
    treatment_started: "Дарылоо башталды",
    turn_on_chat_panel: "Чат панелин иштетүү",
    uis: "UIS",
    uis_integration_instructions: "Dentist Plus менен UIS интеграциялоо үчүн зарыл: <br>1. UIS<br>2 аккаунт түзүңүз. UIS жеке кабинетиңизде керектүү колдонуучунун орнотууларын ачыңыз (мисалы, Администратордун) жана API функциясына кирүү бөлүмүндө 'API ачкычын колдонуу' жөндөөсүн иштетиңиз <br/>3. 'Билдирүүлөр' меню пунктунда 2 эскертме түзүңүз: жооп күтүү жана сүйлөшүүнү аяктоо үчүн. Эки учурда тең HTTP эскертме ыкмасын иштетиңиз жана URL талаасында шилтемени көрсөтүңүз.:<br><span class='text-primary'>{url}</span><br>4. Төмөнкү талаада uis функциясын колдоно турган жана виртуалдык номерлерин толтурган клиниканын кызматкерлерин көрсөтүңүз (чалууларды кабыл алуу жана баштоо үчүн):",
    undergoing_treatment: "Дарылоо",
    unpublish: "Жарыялоодон алып салуу",
    use_common_name_for_documents_for_all_branches: "Бардык филиалдар үчүн документтерде жалпы аталышты колдонуңуз",
    user_add_id: "Автор",
    view: "Карап чыгуу",
    visit_confirm: "Кабыл алууну тастыктоо",
    visit_doctor: "Врачка баруу",
    visit_source: "Визиттин булагы",
    without_tasks: "Тапшырмасыз",
    write_in_messenger: "Мессенджерге жазуу",
    you_also_can_use_link: "Ошондой эле форма шилтемесин түздөн-түз колдоно аласыз"
}
